/* ==========================================================================
   CL · Blog en carrusel — comportamiento
   El carrusel de artículos (featured-blog en modo .cl-blogcar) es scroll
   nativo con la barra oculta: en desktop no había forma de moverlo con
   el mouse. Aquí se agrega:
   - Flechas prev/next (desktop) que avanzan de una card en una.
   - Arrastre con el mouse (drag-to-scroll) en desktop; el touch de
     mobile ya funciona nativo.
   - LOOP INFINITO real en desktop y mobile: se clona el set de cards
     antes y después del original y, cuando el scroll se asienta cerca
     de un extremo, se recoloca de forma invisible sobre el contenido
     equivalente — se puede avanzar o retroceder sin fin, con flechas,
     mouse o dedo.
   - Con pocas cards (sin overflow) no hay loop y las flechas se ocultan.
   ========================================================================== */

(function () {
	'use strict';

	function initBlogCarousel(root) {
		if (!root || root.dataset.clbcInit === 'true') return;
		root.dataset.clbcInit = 'true';

		var wrap = root.querySelector('.blog__posts-wrapper');
		if (!wrap) return;

		var prev = root.querySelector('[data-clbc-prev]');
		var next = root.querySelector('[data-clbc-next]');
		var isDown = false;
		var firstOriginal = null;
		var firstClone = null;

		/* Una card + el gap = un paso del carrusel */
		function step() {
			var card = wrap.querySelector('.blog__post');
			if (!card) return wrap.clientWidth;
			var gap = parseFloat(getComputedStyle(wrap).columnGap) || 0;
			return card.getBoundingClientRect().width + gap;
		}

		function hasOverflow() {
			return wrap.scrollWidth > wrap.clientWidth + 5;
		}

		/* Ancho de UN set completo (se mide en vivo: cambia con el viewport) */
		function setWidth() {
			if (!firstOriginal || !firstClone) return 0;
			return firstOriginal.offsetLeft - firstClone.offsetLeft;
		}

		/* Salto instantáneo e invisible (sin suavizado ni imán) */
		function instantJump(left) {
			wrap.classList.add('is-jumping');
			wrap.scrollLeft = left;
			void wrap.offsetWidth;
			wrap.classList.remove('is-jumping');
		}

		/* ---------- Loop infinito: clones a ambos lados ---------- */
		function setupLoop() {
			if (wrap.querySelector('[data-clbc-clone]')) return;

			var cards = Array.prototype.filter.call(wrap.children, function (child) {
				return child.classList.contains('blog__post');
			});
			if (!cards.length) return;

			var before = document.createDocumentFragment();
			var after = document.createDocumentFragment();

			cards.forEach(function (card) {
				[before, after].forEach(function (frag) {
					var clone = card.cloneNode(true);
					clone.setAttribute('data-clbc-clone', '');
					/* Los clones son solo visuales: fuera del lector de
					   pantalla y del orden de tabulación */
					clone.setAttribute('aria-hidden', 'true');
					clone.querySelectorAll('a, button').forEach(function (el) {
						el.setAttribute('tabindex', '-1');
					});
					frag.appendChild(clone);
				});
			});

			firstOriginal = cards[0];
			wrap.insertBefore(before, wrap.firstChild);
			wrap.appendChild(after);
			firstClone = wrap.children[0];

			/* Arranca sobre el set original (deja sitio para retroceder) */
			instantJump(setWidth());
		}

		/* Al asentarse el scroll cerca de un extremo, se recoloca sobre
		   el set central — el contenido es idéntico, no se nota */
		function rewrap() {
			if (isDown) return;
			var W = setWidth();
			if (!W) return;
			var p = wrap.scrollLeft;
			if (p < W * 0.5) {
				instantJump(p + W);
			} else if (p >= W * 1.5) {
				instantJump(p - W);
			}
		}

		var settleTimer;
		wrap.addEventListener(
			'scroll',
			function () {
				window.clearTimeout(settleTimer);
				settleTimer = window.setTimeout(rewrap, 140);
			},
			{ passive: true }
		);

		/* ---------- Flechas ---------- */
		if (next) {
			next.addEventListener('click', function () {
				wrap.scrollBy({ left: step(), behavior: 'smooth' });
			});
		}

		if (prev) {
			prev.addEventListener('click', function () {
				wrap.scrollBy({ left: -step(), behavior: 'smooth' });
			});
		}

		/* ---------- Arrastre con el mouse (solo desktop) ---------- */
		var moved = false;
		var startX = 0;
		var startLeft = 0;

		wrap.addEventListener('pointerdown', function (event) {
			if (event.pointerType !== 'mouse') return;
			isDown = true;
			moved = false;
			startX = event.clientX;
			startLeft = wrap.scrollLeft;
			wrap.classList.add('is-dragging');
		});

		window.addEventListener('pointermove', function (event) {
			if (!isDown) return;
			var dx = event.clientX - startX;
			if (Math.abs(dx) > 5) moved = true;
			if (moved) wrap.scrollLeft = startLeft - dx;
		});

		window.addEventListener('pointerup', function () {
			if (!isDown) return;
			isDown = false;
			wrap.classList.remove('is-dragging');
			rewrap();
		});

		/* Tras arrastrar, el click que suelta no debe abrir el artículo */
		wrap.addEventListener(
			'click',
			function (event) {
				if (moved) {
					event.preventDefault();
					event.stopPropagation();
					moved = false;
				}
			},
			true
		);

		/* Sin drag nativo de las imágenes (pelearía con el arrastre) */
		wrap.addEventListener('dragstart', function (event) {
			event.preventDefault();
		});

		/* ---------- Arranque ---------- */
		if (hasOverflow()) {
			setupLoop();
		} else {
			/* Pocas cards: sin loop y sin flechas */
			root.classList.add('cl-blogcar--static');
		}
	}

	function initAll() {
		document.querySelectorAll('.cl-blogcar').forEach(initBlogCarousel);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
